<template>
    <fragment>
        <template v-if="!paymentStatus">
            <div class="loader loader--only position-absolute">
                <loader v-show="!iframeHasLoaded" />
            </div>
            <iframe
                class="trustpay-iframe"
                :src="iframeSrc"
                @load="iframeHasLoaded = true;"
                :style="{ visibility: iframeHasLoaded ? 'visible' : 'hidden' }"
            ></iframe>
        </template>
        <Response v-else></Response>
    </fragment>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import route from '@H/route';
import querystring from 'querystring';
import Response from './Response';

export default {
    components: {
        Response
    },
    data() {
        return {
            iframeHasLoaded: false,
            subscriptionUpgradeId: null
        }
    },
    mounted() {
        // We cannot do a 'Vue' redirect from inside the trustpay iframe, and doing a window.location redirect causes us to lose the vuex state 
        // So instead we send a message with the payment status from within the iframe - Listen for it here, and handle however we need to within a vue context.
        window.addEventListener('message', this.checkPaymentStatus, false);
    },
    methods: {
        ...mapMutations('Widget', ['setSubscriptionUpgradeId', 'setPaymentStatus']),
        ...mapMutations('MySubscriptions', ['mySubscriptionsInitial']),
        checkPaymentStatus(event) {
            // A router.push wasn't working here, so instead we can just render the response screen component using a v-if and store the bits we need in vuex
            if (event.data.type === 'payment_status') {

                if (event.data.status === 'CANCELLED') {
                    this.mySubscriptionsInitial(false);
                    // If the processed was cancelled head back to the my subscriptions page
                    // The router was breaking trying to navigate here so just refresh the page instead.
                    window.location.href = '/my-subscriptions';
                    return;
                }

                this.setPaymentStatus(event.data.status);
                this.setSubscriptionUpgradeId(event.data.subscriptionUpgradeId);
            }
        },
    },
    computed: {
        ...mapState('Widget', ['paymentStatus']),
        iframeSrc() {
            // When we've got a status, we don't need to bother with the iframe anymore because it means the response has already come back
            if (this.paymentStatus) return;

            let params = {
                code: this.$store.state.Widget.token,
                subscriptionId: this.$store.state.Widget.selectedUpgrade.subscriptionId,
                pricingOptionId: this.$store.state.Widget.selectedUpgrade.pricingOption.id,
                price: this.$store.state.Widget.selectedUpgrade.pricingOption.price
            };

            return route('mysubs.initiate-upgrade') + '?' + querystring.stringify(params);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/MySubscriptions/Payment.vue